import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Provider } from 'react-redux';
import 'rc-easyui/dist/themes/default/easyui.css';
import reportWebVitals from './reportWebVitals';
import store, { persistor } from './store/store';
import Router from './Routes';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ThemeProvider } from '@mui/material/styles';
import uiSapTheme from './theme/uiSapTheme';
import './styles/ui-sap-2026.css';
 
const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement); 
document.body.classList.add('ui-sap-2026');
root.render(
  <ThemeProvider theme={uiSapTheme}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </ThemeProvider>
);

reportWebVitals();
